(($)=>{
    "use strict";

    $('.quote-slider').slick({
        arrows: false,
        dots: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500
    });


})(jQuery);